import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-archive-confirmation-dialog',
  standalone: false,
  templateUrl: './archive-confirmation-dialog.component.html',
  styleUrl: './archive-confirmation-dialog.component.scss'
})
export class ArchiveConfirmationDialogComponent {
  constructor(public dialogRef: MatDialogRef<ArchiveConfirmationDialogComponent>) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onArchive(): void {
    this.dialogRef.close(true);
  }
}
